import React from 'react';

import PropTypes from 'prop-types';

import { Input } from 'ui-components/components/input';
import { noop } from 'ui-components/default-props/noop';

export const TextInput = ({
  name,
  type = '',
  placeholder = '',
  componentClassName,
  countryCode = '',
  hasError = false,
  onChange,
  onBlur = noop,
  value = '',
  disabled = false,
}) => (
  <div className={componentClassName}>
    <Input
      data-testid={`${countryCode}-${name}`}
      disabled={disabled}
      hasError={hasError}
      label=''
      name={name}
      onBlur={onBlur}
      onChange={onChange}
      placeholder={placeholder}
      type={type}
      value={value || ''}
    />
  </div>
);

TextInput.propTypes = {
  hasError: PropTypes.bool,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  onBlur: PropTypes.func,
  componentClassName: PropTypes.string,
  countryCode: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  disabled: PropTypes.bool,
};
